import { z } from 'zod'

export const getContractInformationResponseSchema = z.object({
  /** 狀態 */
  status: z.string(),
  /** issue起始日期 */
  issueStartTime: z.string(),
  /** issue截止日期	 */
  issueEndTime: z.string()
})

export interface GetContractInformationResponse
  extends z.infer<typeof getContractInformationResponseSchema> {}

export class GetContractInformationResponse {
  constructor() {
    return {
      status: '',
      issueStartTime: '',
      issueEndTime: ''
    }
  }
}
